export default "__VITE_ASSET__C1kDsJDr__"